export const FAQ = '';

export const APP_MANAGED_ROUTES = {
  FORMS_CENTER_ROUTE: `/forms-center`,
  ABOUT_CIGNA_ROUTE: `/about`,
  HOME: `/home`,
  SIGN_IN: `/sign-in`,
  SIGN_OUT: `/sign-out`,
  LEARN_ABOUT_AUTHORIZATION: '/learn-about-authorizations',
  PROFILE_SETTINGS: '/profile-settings',
  SECURITY_SETTINGS: '/security-settings',
  CUSTOMER_SUPPORT: '/customer-support',
  PDP_PREMIUM_PAYMENT: '/pdp-premium-payment',
  SUPPLEMENTAL_PREMIUM_PAYMENT: '/supplemental-premium-payments',
  MEDICARE_PREMIUM_PAYMENT: '/sso/vendors/mycigna?redirect_key=bankofamerica',
  MEDICARE_PRESCRIPTION_PAYMENT_PLAN: '/medicare-prescription-payment-plan',
  PREMIUM_PAYMENT_HISTORY: '/premium-payment-history',
  PAYMENT_COMPLETED: '/settings/account/payment/setup/complete',
  AUTOMATIC_PAYMENT_SETUP: '/automatic-payments-setup',
};

export const CARE_ADVISOR_EMAIL = 'careadvisorconnect@optum.com';
export const CARE_ADVISOR_PHONE_NUMBER = '866-658-4644';
export const VIEW_HEALTH_INFORMATION_AUTHORIZATION_PATH =
  '/view-health-authorization';

export const MASONRY = {
  API_VERSION: 1,
  CUSTOM_WIDGET_TYPE_HEALTHLINK_LOGO: 'healthlink_logo',
  HEALTH_JOURNEY_MODULE_KEY: 'health_journey',
  CUSTOM_WIDGET_TYPE_HEALTH_JOURNEY: 'health_journey',
  MESSAGING_MODULE_KEY: 'messaging',
  CUSTOM_WIDGET_TYPE_MESSAGING: 'recent_messages',
  MODULE_KEY_CLAIMS: 'claims',
  CUSTOM_WIDGET_TYPE_CLAIMS: 'recent_claims_cards',
  CUSTOM_WIDGET_TYPE_ACTIVITY: 'activity_stack',
};

export const MESSAGE_TYPES = {
  GET_APP_INIT_DETAILS: 'get_app_init_details',
  GET_WIDGET_CONTAINER: 'get_widget_container',
};

export const CALLBACK_STATUS = {
  QUEUED: 'QUEUED',
  COMPLETED: 'COMPLETED',
};

export const AUTH0_ERROR_TYPES = {
  LOGIN_REQUIRED: 'login_required',
};

export const SECURITY_SETTINGS_ACTIONS = [
  {
    titleId: 'STR_CHANGE_PASSWORD',
    icon: 'descriptiveLockPerson',
    linkUrl: '/sso/vendors/mycigna?redirect_key=change-password',
  },
  {
    titleId: 'STR_CHANGE_MFA',
    icon: 'descriptiveLockTree',
    linkUrl: '/sso/vendors/mycigna?redirect_key=mfa-update',
  },
  {
    titleId: 'STR_CHANGE_SECURITY_QUESTIONS',
    icon: 'descriptiveQuestionBox',
    linkUrl: '/sso/vendors/mycigna?redirect_key=security-question',
  },
];

/* eslint-disable no-irregular-whitespace */
export const ABOUT_US_DESCRIPTION_TEXT = `
<div>
    <p>A powerful, full-featured tool for managing all aspects of your health care on the go.</p>
    <h3>myHealthSpring Features</h3>
    <p>​​​​Based on your health care plan, you may not have all the features described below.</p>
    <h6>ID Cards</h6>
    <ul>
        <li>Instantly view ID cards (front and back)</li>
        <li>Easily print, email, fax, or scan right from your mobile device</li>
    </ul>
    <h6>Claims & EOBs</h6>
    <ul>
        <li>View and filter recent and past claims</li>
        <li>Download EOBs</li>
    </ul>
    <h6>Account Balances</h6>
    <ul>
        <li>Review plan deductibles and coinsurance</li>
        <li>Submit request for reimbursement</li>
    </ul>
    <h6>Home Delivery Pharmacy</h6>
    <ul>
        <li>View and refill your prescriptions right from your mobile device</li>
        <li>Update billing and shipping references</li>
    </ul>
    <h6>Drug Search</h6>
    <ul>
        <li>Look up and compare actual costs at 60,000 pharmacies nationwide</li>
        <li>Find closest pharmacy location using GPS</li>
        <li>Speed-dial HealthSpring Home Delivery Pharmacy</li>
    </ul>
    <h6>Health Care Professional Directory</h6>
    <ul>
        <li>Search for a doctor, dentist, pharmacy, or health care facility from HealthSpring’s national network and compare quality-of-care ratings</li>
    </ul>
    <h6>HealthSpring Telehealth Connection</h6>
    <ul>
        <li>Connect with nationwide network of doctors via video or phone</li>
    </ul>
    <h6>Benefits & Coverage</h6>
    <ul>
        <li>View plan coverage and authorizations</li>
        <li>Find what is covered under your plan</li>
    </ul>
    <h6>Languages Supported</h6>
    <ul>
        <li>English</li>
    </ul>
    <h6>Safe & Secure</h6>
    <ul>
        <li>We use the latest technology in secure mobile applications to protect your personal health info while online or off. </li>
    </ul>
</div>
`;

export const SENTRY_CONSTANTS = {
  OWNERSHIP_TEAM: 'cigna-web',
  NO_INFO_AVAILABLE: 'no info available',
};

export const AUTH_VALIDATION_ERRORS = {
  DELETED_USER: 'unable_to_login_deleted_user',
  INELIGIBLE_USER: 'unable_to_login_ingeligible_user',
};

export const EXTERNAL_LINK = {
  LANGUAGE_ASSISTANCE:
    'https://www.healthspring.com/static/docs/medicare/resources/notice-of-availability.pdf',
  GRIEVANCES:
    'https://www.healthspring.com/medicare/member-resources/grievances',
  GRIEVANCES_AND_APPEALS:
    'https://www.healthspring.com/medicare/member-resources/grievances',
  LEGAL_AND_PRIVACY: 'https://www.healthspring.com/legal-privacy',
  PRIVACY_POLICY: 'www.healthspring.com/legal-privacy',

  NONDISCRIMINATION_NOTICE:
    'https://www.healthspring.com/static/docs/medicare/resources/notice-nondiscrimination.pdf',
  MY_CIGNA: 'https://www.healthspring.com/',
};

export const EXTERNAL_SSO_LINK = {
  PROFILE_SETTINGS_COMMUNICATION_INF0_SSO_LINK:
    '/sso/vendors/mycigna?redirect_key=mfa-update',
  MANAGE_PHARMACY_SETTINGS: '/sso/vendors/expressscripts?content_area=orderrx',
};

export const US_STATES = [
  { label: 'AL', value: 'AL' },
  { label: 'AK', value: 'AK' },
  { label: 'AZ', value: 'AZ' },
  { label: 'AR', value: 'AR' },
  { label: 'CA', value: 'CA' },
  { label: 'CO', value: 'CO' },
  { label: 'CT', value: 'CT' },
  { label: 'DE', value: 'DE' },
  { label: 'FL', value: 'FL' },
  { label: 'GA', value: 'GA' },
  { label: 'HI', value: 'HI' },
  { label: 'ID', value: 'ID' },
  { label: 'IL', value: 'IL' },
  { label: 'IN', value: 'IN' },
  { label: 'IA', value: 'IA' },
  { label: 'KS', value: 'KS' },
  { label: 'KY', value: 'KY' },
  { label: 'LA', value: 'LA' },
  { label: 'ME', value: 'ME' },
  { label: 'MD', value: 'MD' },
  { label: 'MA', value: 'MA' },
  { label: 'MI', value: 'MI' },
  { label: 'MN', value: 'MN' },
  { label: 'MS', value: 'MS' },
  { label: 'MO', value: 'MO' },
  { label: 'MT', value: 'MT' },
  { label: 'NE', value: 'NE' },
  { label: 'NV', value: 'NV' },
  { label: 'NH', value: 'NH' },
  { label: 'NJ', value: 'NJ' },
  { label: 'NM', value: 'NM' },
  { label: 'NY', value: 'NY' },
  { label: 'NC', value: 'NC' },
  { label: 'ND', value: 'ND' },
  { label: 'OH', value: 'OH' },
  { label: 'OK', value: 'OK' },
  { label: 'OR', value: 'OR' },
  { label: 'PA', value: 'PA' },
  { label: 'RI', value: 'RI' },
  { label: 'SC', value: 'SC' },
  { label: 'SD', value: 'SD' },
  { label: 'TN', value: 'TN' },
  { label: 'TX', value: 'TX' },
  { label: 'UT', value: 'UT' },
  { label: 'VT', value: 'VT' },
  { label: 'VA', value: 'VA' },
  { label: 'DC', value: 'DC' },
  { label: 'WV', value: 'WV' },
  { label: 'WI', value: 'WI' },
  { label: 'WY', value: 'WY' },
];

export enum CoverageExperience {
  Active = 'active',
  PreEffective = 'pre_effective',
  PostEffective = 'post_effective',
}

export const MEDICARE_PRODUCTS = ['ma', 'mapd', 'pdp'] as const;
export const CSB_PRODUCTS = ['medsupp', 'dvh', 'shl'] as const;
export const MA_MAPD_PRODUCTS = ['ma', 'mapd'] as const;
export const PDP_PRODUCT = 'pdp' as const;
